export const hideChartSkeleton = (container: HTMLElement | null): void => {
	if (container === null) {
		return
	}

	const host = container.closest<HTMLElement>('.chart-skeleton-host')
	host?.querySelector<HTMLElement>('.chart-skeleton')?.classList.add('hidden')
}
